/* eslint-disable import/prefer-default-export */

export const validateField = (value, validators) => {
  let errorMessage = false;
  let errorKey = false;
  if (!validators || typeof validators !== 'object') {
    return { errorKey, errorMessage };
  }

  Object.keys(validators).some((i) => {
    // Check if value passes validator
    const passed = validators[i].validator(value);
    if (!passed) {
      // If not passed, stop & return error
      errorMessage = validators[i].message;
      errorKey = i;
      return true;
    }
    // Else continue checking
    return false;
  });

  return { errorKey, errorMessage };
};
